export default "__VITE_ASSET__C3sz2zgs__"